/* eslint-disable i18next/no-literal-string */
import React from 'react';
import { Card, CardContent, CardActions, Button, Container, Typography } from '@mui/material';

export default function ExcelDownloadPage() {
  return (
      <Card>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Download Staff Member File
          </Typography>
        </CardContent>
        <CardActions>
          <Button
            variant="contained"
            href="/setup-templates/staff_member.ods"
            download
          >
            Download ODS
          </Button>
          <Button
            variant="outlined"
            href="/setup-templates/staff_member.csv"
            download
          >
            Download CSV
          </Button>
        </CardActions>
      </Card>
  );
}
